import { Badge } from '@common/components';
import { FOCUS_RING } from '@common/components/interaction';
import SvgChevronright from '@common/icon/SvgChevronright';
import { cn } from '@core/utils';
import type { ReactNode } from 'react';

import { CustomLink } from '@/app/_components/CustomLink';

interface BenefitHomeSectionHeaderProps {
  title: ReactNode;
  icon?: ReactNode;
  isNew?: boolean;
  moreHref?: string;
}

export const BenefitHomeSectionHeader = ({
  title,
  icon,
  isNew = false,
  moreHref,
}: BenefitHomeSectionHeaderProps) => (
  <div className="flex items-center justify-between gap-8">
    <h2 className="flex items-center gap-4 font-700 text-Gray-900 typo-body3">
      {icon ? (
        //* 한글 잉크가 줄 박스 중심보다 위에 앉아 입체 코인이 처져 보이므로 1px 올린다
        <span className="relative -top-1 flex shrink-0">{icon}</span>
      ) : null}
      <span>{title}</span>
      {isNew ? (
        <Badge dimensions="H20" className="bg-B-500 text-Gray-white">
          신규
        </Badge>
      ) : null}
    </h2>
    {moreHref ? (
      <CustomLink
        href={moreHref}
        className={cn(
          'group -m-4 flex shrink-0 items-center gap-4 rounded-xxsmall p-4 font-500 text-Gray-600 typo-body4 hover:text-Gray-700 focus-visible:text-Gray-700 active:text-Gray-700',
          FOCUS_RING,
        )}
      >
        더보기
        <SvgChevronright className="size-16 text-Gray-600 transition group-hover:translate-x-1 group-hover:text-Gray-700 group-focus-visible:translate-x-1 group-focus-visible:text-Gray-700 group-active:text-Gray-700" />
      </CustomLink>
    ) : null}
  </div>
);
